export default __webpack_public_path__ + "static/media/gear.fa4185aa.png";